/**
 * Unified Color Configuration
 * Generated by CreateProjectService
 */

export default {
  "theme": {
    "primary": {
      "50": "#f5f7f9",
      "100": "#e9edf6",
      "200": "#c7d4f0",
      "300": "#8eabec",
      "400": "#487bea",
      "500": "#1554e0",
      "600": "#2563eb",
      "700": "#0f3fa8",
      "800": "#0f3280",
      "900": "#0d2559",
      "950": "#091734"
    },
    "accent": {
      "50": "#f5f9f7",
      "100": "#e9f6ef",
      "200": "#c5f1db",
      "300": "#8beebb",
      "400": "#44ee96",
      "500": "#0ee677",
      "600": "#0cc063",
      "700": "#0bad59",
      "800": "#0c8345",
      "900": "#0b5c32",
      "950": "#08361e"
    },
    "secondary": {
      "50": "#f7f5f9",
      "100": "#eee9f6",
      "200": "#d6c6f0",
      "300": "#b08eec",
      "400": "#8448ea",
      "500": "#6014e0",
      "600": "#7c3aed",
      "700": "#480fa8",
      "800": "#390f80",
      "900": "#290d59",
      "950": "#190934"
    },
    "neutral": {
      "50": "#f7f7f8",
      "100": "#eeeff1",
      "200": "#d7dbdf",
      "300": "#b4bbc6",
      "400": "#8996a9",
      "500": "#66778e",
      "600": "#64748b",
      "700": "#4d596b",
      "800": "#3c4552",
      "900": "#2c323a",
      "950": "#1a1e23"
    },
    "html": {
      "heading1": {
        "light": "#1e293b",
        "dark": "#f8fafc"
      },
      "heading2": {
        "light": "#334155",
        "dark": "#e2e8f0"
      },
      "heading3": {
        "light": "#475569",
        "dark": "#cbd5e1"
      },
      "heading4": {
        "light": "#475569",
        "dark": "#94a3b8"
      },
      "heading5": {
        "light": "#64748b",
        "dark": "#94a3b8"
      },
      "heading6": {
        "light": "#64748b",
        "dark": "#64748b"
      },
      "body": {
        "light": "#334155",
        "dark": "#e2e8f0"
      },
      "link": {
        "light": "#4f46e5",
        "dark": "#a5b4fc"
      },
      "linkHover": {
        "light": "#4338ca",
        "dark": "#c7d2fe"
      },
      "code": {
        "bg": {
          "light": "#f1f5f9",
          "dark": "#1e293b"
        },
        "text": {
          "light": "#3730a3",
          "dark": "#a5b4fc"
        }
      },
      "pre": {
        "bg": {
          "light": "#f8fafc",
          "dark": "#0f172a"
        },
        "text": {
          "light": "#0f172a",
          "dark": "#f1f5f9"
        },
        "border": {
          "light": "#e2e8f0",
          "dark": "#334155"
        }
      },
      "blockquote": {
        "border": {
          "light": "#10b981",
          "dark": "#34d399"
        },
        "bg": {
          "light": "#ecfdf5",
          "dark": "transparent"
        },
        "text": {
          "light": "#334155",
          "dark": "#cbd5e1"
        }
      },
      "hr": {
        "light": "#e2e8f0",
        "dark": "#334155"
      },
      "table": {
        "border": {
          "light": "#e2e8f0",
          "dark": "#334155"
        },
        "headerBg": {
          "light": "#f8fafc",
          "dark": "#1e293b"
        },
        "headerText": {
          "light": "#0f172a",
          "dark": "#f1f5f9"
        }
      },
      "strong": {
        "light": "#0f172a",
        "dark": "#ffffff"
      },
      "em": {
        "light": "#334155",
        "dark": "#cbd5e1"
      },
      "mark": {
        "bg": {
          "light": "#e0e7ff",
          "dark": "#4f46e5"
        },
        "text": {
          "light": "#0f172a",
          "dark": "#ffffff"
        }
      }
    },
    "blog": {
      "heading1": {
        "light": "#1e293b",
        "dark": "#f8fafc"
      },
      "heading2": {
        "light": "#3730a3",
        "dark": "#a5b4fc"
      },
      "heading3": {
        "light": "#10b981",
        "dark": "#34d399"
      },
      "heading4": {
        "light": "#475569",
        "dark": "#cbd5e1"
      },
      "heading5": {
        "light": "#64748b",
        "dark": "#94a3b8"
      },
      "heading6": {
        "light": "#64748b",
        "dark": "#94a3b8"
      },
      "body": {
        "light": "#475569",
        "dark": "#e2e8f0"
      },
      "link": {
        "light": "#4f46e5",
        "dark": "#a5b4fc"
      },
      "linkHover": {
        "light": "#4338ca",
        "dark": "#c7d2fe"
      },
      "code": {
        "bg": {
          "light": "#eef2ff",
          "dark": "#1e293b"
        },
        "text": {
          "light": "#3730a3",
          "dark": "#a5b4fc"
        }
      },
      "pre": {
        "bg": {
          "light": "#f0fdfa",
          "dark": "#0f172a"
        },
        "text": {
          "light": "#0f172a",
          "dark": "#f8fafc"
        },
        "border": {
          "light": "#a7f3d0",
          "dark": "#334155"
        }
      },
      "blockquote": {
        "border": {
          "light": "#10b981",
          "dark": "#34d399"
        },
        "bg": {
          "light": "#ecfdf5",
          "dark": "transparent"
        },
        "text": {
          "light": "#334155",
          "dark": "#cbd5e1"
        }
      },
      "hr": {
        "light": "#a7f3d0",
        "dark": "#334155"
      },
      "table": {
        "border": {
          "light": "#e2e8f0",
          "dark": "#334155"
        },
        "headerBg": {
          "light": "#eef2ff",
          "dark": "#1e293b"
        },
        "headerText": {
          "light": "#0f172a",
          "dark": "#f8fafc"
        }
      },
      "strong": {
        "light": "#0f172a",
        "dark": "#ffffff"
      },
      "em": {
        "light": "#334155",
        "dark": "#cbd5e1"
      },
      "mark": {
        "bg": {
          "light": "#e0e7ff",
          "dark": "#4f46e5"
        },
        "text": {
          "light": "#0f172a",
          "dark": "#ffffff"
        }
      }
    }
  },
  "app": {
    "background": "#f8fafc",
    "backgroundSecondary": "#f1f5f9",
    "sideMenuBackground": "#f1f5f9",
    "bannerBackground": "#4f46e5",
    "bannerText": "#e0e7ff",
    "bannerTextHover": "#c7d2fe",
    "blogHeaderText": "#1e293b",
    "link": "#4f46e5",
    "linkHover": "#4338ca",
    "button": {
      "text": "#ffffff",
      "background": "#4f46e5",
      "backgroundHover": "#4338ca",
      "backgroundDisabled": "#94a3b8",
      "backgroundSecondary": "#64748b",
      "backgroundSecondaryHover": "#475569",
      "backgroundTertiary": "#e2e8f0",
      "backgroundTertiaryHover": "#cbd5e1"
    },
    "ctaButton": {
      "text": "#ffffff",
      "background": "#6366f1",
      "backgroundHover": "#22c55e"
    },
    "form": {
      "control": "#64748b",
      "borderInput": "#cbd5e1"
    },
    "status": {
      "success": "#16a34a",
      "successBackground": "#dcfce7",
      "warning": "#d97706",
      "warningBackground": "#fef3c7",
      "error": "#dc2626",
      "errorBackground": "#fee2e2",
      "danger": "#b91c1c",
      "dangerBackground": "#fee2e2"
    },
    "rowTextHighlight": "#4f46e5",
    "socialAuth": {
      "google": {
        "background": "#ffffff",
        "text": "#EA4335",
        "border": "#dddddd",
        "hover": "#f8f8f8",
        "icon": "#EA4335"
      },
      "facebook": {
        "background": "#1877f2",
        "text": "#ffffff",
        "hover": "#166fe5"
      },
      "github": {
        "background": "#24292e",
        "text": "#ffffff",
        "hover": "#2f363d"
      },
      "twitter": {
        "background": "#1da1f2",
        "text": "#ffffff",
        "hover": "#1a91da"
      },
      "apple": {
        "background": "#000000",
        "text": "#ffffff",
        "hover": "#1a1a1a"
      }
    },
    "trust": {
      "pending": "#d97706",
      "pendingBg": "#fef3c7",
      "accepted": "#16a34a",
      "acceptedBg": "#dcfce7",
      "declined": "#dc2626",
      "declinedBg": "#fee2e2",
      "quotaNormal": "#16a34a",
      "quotaWarning": "#d97706",
      "quotaCritical": "#dc2626"
    },
    "actionButton": {
      "primary": {
        "text": "#ffffff",
        "background": "#4f46e5",
        "backgroundHover": "#4338ca",
        "backgroundActive": "#3730a3",
        "border": "#4f46e5",
        "borderHover": "#4338ca",
        "focusRing": "#6366f1"
      },
      "secondary": {
        "text": "#334155",
        "textDark": "#e2e8f0",
        "background": "#f1f5f9",
        "backgroundDark": "#1e293b",
        "backgroundHover": "#e2e8f0",
        "backgroundHoverDark": "#334155",
        "border": "#cbd5e1",
        "borderDark": "#475569",
        "focusRing": "#64748b"
      },
      "tertiary": {
        "text": "#64748b",
        "textDark": "#94a3b8",
        "background": "transparent",
        "backgroundHover": "#f1f5f9",
        "backgroundHoverDark": "#1e293b",
        "border": "transparent",
        "focusRing": "#94a3b8"
      },
      "danger": {
        "text": "#ffffff",
        "background": "#dc2626",
        "backgroundHover": "#b91c1c",
        "backgroundActive": "#991b1b",
        "border": "#dc2626",
        "borderHover": "#b91c1c",
        "focusRing": "#ef4444"
      },
      "success": {
        "text": "#ffffff",
        "background": "#16a34a",
        "backgroundHover": "#15803d",
        "backgroundActive": "#166534",
        "border": "#16a34a",
        "borderHover": "#15803d",
        "focusRing": "#22c55e"
      },
      "warning": {
        "text": "#ffffff",
        "background": "#d97706",
        "backgroundHover": "#b45309",
        "backgroundActive": "#92400e",
        "border": "#d97706",
        "borderHover": "#b45309",
        "focusRing": "#f59e0b"
      },
      "disabled": {
        "text": "#94a3b8",
        "textDark": "#475569",
        "background": "#f1f5f9",
        "backgroundDark": "#1e293b",
        "border": "#e2e8f0",
        "borderDark": "#334155",
        "opacity": 0.5,
        "cursor": "not-allowed"
      }
    }
  },
  "semantic": {
    "headerBg": "bg-primary-50/95 dark:bg-neutral-900/95 backdrop-blur-sm border-b border-primary-200 dark:border-neutral-700/10",
    "headerText": "text-neutral-800 dark:text-neutral-200",
    "navLink": "text-neutral-700 hover:text-primary-600 dark:text-neutral-300 dark:hover:text-primary-400",
    "navLinkActive": "text-primary-600 dark:text-primary-400",
    "navLinkHover": "hover:text-primary-600 dark:hover:text-primary-400",
    "mobileMenuBg": "bg-white/95 dark:bg-neutral-900/95 backdrop-blur-sm",
    "headerButtonBg": "bg-white dark:bg-neutral-800",
    "headerButtonBorder": "border-primary-200 dark:border-neutral-700",
    "headerButtonText": "text-neutral-800 dark:text-neutral-200",
    "headerButtonHover": "hover:bg-primary-50 dark:hover:bg-neutral-700",
    "footerBg": "bg-neutral-100 dark:bg-neutral-900",
    "footerText": "text-neutral-600 dark:text-neutral-400",
    "footerLink": "text-neutral-900 dark:text-neutral-200",
    "footerLinkHover": "hover:text-accent-400 dark:hover:text-accent-400",
    "bodyBg": "bg-white dark:bg-neutral-900",
    "bodyText": "text-neutral-800 dark:text-neutral-200",
    "heroTitle": "bg-gradient-to-r from-primary-600 to-accent-600 bg-clip-text text-transparent",
    "heroSubtitle": "text-neutral-700 dark:text-neutral-400",
    "heroButtonPrimary": "cta-button-primary",
    "heroButtonSecondary": "bg-transparent text-neutral-800 dark:text-neutral-300 border-2 border-neutral-600 dark:border-neutral-600 hover:bg-neutral-600 dark:hover:bg-neutral-600 hover:text-white",
    "heroStatNumber": "text-accent-600 dark:text-accent-400",
    "heroStatLabel": "text-neutral-700 dark:text-neutral-400",
    "featureCardBg": "bg-white dark:bg-neutral-900",
    "featureCardBorder": "border-neutral-200 dark:border-neutral-700",
    "featureCardBorderHover": "border-accent-400 dark:border-accent-400",
    "featureCardHoverBg": "hover:bg-white dark:hover:bg-neutral-900",
    "featureCardHeading": "text-neutral-900 dark:text-white",
    "featureCardText": "text-neutral-700 dark:text-neutral-400",
    "sectionBg": "bg-neutral-100 dark:bg-neutral-800/40",
    "sectionBgAlt": "bg-white dark:bg-neutral-900",
    "sectionBgAlt2": "bg-primary-50/30 dark:bg-primary-900/10",
    "sectionHeading": "text-primary-900 dark:text-primary-100",
    "sectionText": "text-neutral-700 dark:text-neutral-400",
    "contentCardBg": "bg-white dark:bg-neutral-900",
    "contentCardBorder": "border-neutral-200 dark:border-neutral-700",
    "contentCardHeading": "text-neutral-900 dark:text-white",
    "contentCardText": "text-neutral-700 dark:text-neutral-300",
    "contentCardLink": "text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 hover:underline",
    "formBg": "bg-white dark:bg-neutral-700",
    "formBorder": "border-neutral-300 dark:border-neutral-600",
    "formText": "text-neutral-900 dark:text-neutral-100",
    "formLabel": "text-neutral-700 dark:text-neutral-300",
    "formPlaceholder": "placeholder-neutral-500 dark:placeholder-neutral-500",
    "buttonSecondary": "bg-secondary-100 hover:bg-secondary-200 text-secondary-800",
    "buttonPrimary": "bg-primary-600 hover:bg-primary-700 text-white",
    "actionButtonPrimary": "bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500",
    "actionButtonSecondary": "bg-neutral-100 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-200 hover:bg-neutral-200 dark:hover:bg-neutral-700 focus:ring-neutral-500",
    "actionButtonTertiary": "bg-transparent text-neutral-500 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-neutral-800 focus:ring-neutral-400",
    "actionButtonDanger": "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500",
    "actionButtonSuccess": "bg-accent-600 text-white hover:bg-accent-700 focus:ring-accent-500",
    "actionButtonWarning": "bg-amber-600 text-white hover:bg-amber-700 focus:ring-amber-500",
    "actionButtonAdd": "bg-accent-600 text-white hover:bg-accent-700 focus:ring-accent-500",
    "actionButtonEdit": "bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500",
    "actionButtonDelete": "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500",
    "actionButtonSave": "bg-accent-600 text-white hover:bg-accent-700 focus:ring-accent-500",
    "actionButtonSearch": "bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500",
    "actionButtonReset": "bg-neutral-100 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-200 hover:bg-neutral-200 dark:hover:bg-neutral-700 focus:ring-neutral-500",
    "actionButtonSync": "bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500",
    "actionButtonCopy": "bg-neutral-100 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-200 hover:bg-neutral-200 dark:hover:bg-neutral-700 focus:ring-neutral-500",
    "actionButtonExport": "bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500",
    "actionButtonFilter": "bg-neutral-100 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-200 hover:bg-neutral-200 dark:hover:bg-neutral-700 focus:ring-neutral-500",
    "actionButtonRemove": "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500",
    "actionButtonGenerate": "bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500",
    "actionButtonConvert": "bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500",
    "actionButtonInvalidate": "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500",
    "actionButtonBuy": "bg-accent-600 text-white hover:bg-accent-700 focus:ring-accent-500",
    "actionButtonPurchase": "bg-accent-600 text-white hover:bg-accent-700 focus:ring-accent-500",
    "actionButtonCheckout": "bg-accent-600 text-white hover:bg-accent-700 focus:ring-accent-500",
    "highlightPrimaryBg": "bg-primary-100 dark:bg-primary-900/20",
    "highlightPrimaryBorder": "border-primary-500 dark:border-primary-800",
    "highlightPrimaryText": "text-primary-700 dark:text-primary-300",
    "highlightAccentBg": "bg-accent-100 dark:bg-accent-900/20",
    "highlightAccentBorder": "border-accent-500 dark:border-accent-800",
    "highlightAccentText": "text-accent-700 dark:text-accent-300",
    "decorativeAccentBg": "bg-accent-100/20 dark:bg-accent-900/30",
    "decorativePrimaryBg": "bg-primary-100/20 dark:bg-primary-900/30",
    "decorativeSecondaryBg": "bg-secondary-100/20 dark:bg-secondary-900/30",
    "glassBg": "bg-white/60 dark:bg-neutral-800/60 backdrop-blur-lg",
    "glassBorder": "border-neutral-200/50 dark:border-neutral-700/50",
    "glassText": "text-neutral-800 dark:text-neutral-200",
    "interactiveHover": "hover:border-primary-500 dark:hover:border-primary-400",
    "interactiveFocus": "focus:ring-2 focus:ring-primary-500/20",
    "iconContainerBg": "bg-primary-100 dark:bg-primary-900/30",
    "iconContainerText": "text-primary-600 dark:text-primary-400",
    "iconContainerHover": "group-hover:bg-primary-200 dark:group-hover:bg-primary-800/40",
    "cardHoverBorder": "hover:border-primary-500 dark:hover:border-primary-400",
    "cardHoverBg": "hover:bg-primary-50 dark:hover:bg-primary-900/20",
    "tabActive": "bg-primary-500 text-white",
    "tabInactive": "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-neutral-300",
    "tabInactiveHover": "hover:bg-slate-200 dark:hover:bg-slate-700",
    "socialIconBg": "bg-white dark:bg-white",
    "socialIconBorder": "border-neutral-900 dark:border-neutral-900",
    "socialIconHover": "hover:border-primary-500 dark:hover:border-primary-400",
    "starRating": "text-accent-400",
    "processLine": "bg-slate-200 dark:bg-slate-700",
    "processNode": "bg-primary-500",
    "processNodeBorder": "border-primary-500 dark:border-primary-400",
    "processNodeText": "text-primary-500",
    "processNumber": "text-slate-100 dark:text-slate-800",
    "avatarBorder": "border-white dark:border-slate-800",
    "avatarFallback": "bg-slate-200",
    "teamRole": "text-primary-500",
    "socialLink": "text-slate-400",
    "socialLinkHover": "hover:text-primary-500",
    "pricingCardBg": "bg-slate-100 dark:bg-slate-800",
    "pricingCardText": "text-slate-900 dark:text-white",
    "pricingCardHover": "hover:bg-slate-200 dark:hover:bg-slate-700",
    "pricingCardRecommendedBg": "bg-white dark:bg-neutral-900 border border-primary-200 dark:border-primary-700",
    "pricingToggleBg": "bg-slate-200 dark:bg-slate-700",
    "pricingDiscount": "text-green-500 dark:text-green-400",
    "pricingTableBg": "bg-slate-50 dark:bg-slate-900/50",
    "pricingTableBorder": "border-slate-200 dark:border-neutral-700",
    "pricingTableHover": "hover:bg-slate-50 dark:hover:bg-slate-800/50",
    "videoControlBg": "bg-white/90",
    "videoControlText": "text-gray-900",
    "videoControlHover": "hover:bg-white",
    "navBackdrop": "bg-white/80 dark:bg-slate-900/80",
    "loadingOverlayBg": "bg-neutral-900/60 dark:bg-neutral-900/80",
    "loadingSpinnerBorder": "border-primary-200 dark:border-neutral-700",
    "loadingSpinnerActive": "border-t-primary-600 dark:border-t-primary-400",
    "loadingText": "text-neutral-700 dark:text-neutral-200",
    "blogPostBg": "bg-white dark:bg-neutral-900",
    "blogPostHeading1": "text-primary-700 dark:text-white",
    "blogPostHeading2": "text-primary-700 dark:text-white",
    "blogPostHeading3": "text-accent-500 dark:text-accent-400",
    "blogPostMeta": "text-neutral-600 dark:text-neutral-400",
    "blogPostLink": "text-accent-500 dark:text-accent-400",
    "categoryBadge": "bg-primary-100 dark:bg-primary-700 text-primary-900 dark:text-white",
    "tagBadge": "bg-accent-100 dark:bg-accent-600 text-accent-900 dark:text-white",
    "cardBg": "bg-white dark:bg-neutral-800",
    "cardBorder": "border-neutral-200 dark:border-neutral-700",
    "cardText": "text-neutral-800 dark:text-neutral-200",
    "buttonSecondaryText": "text-slate-900 dark:text-white",
    "buttonSecondaryBorder": "border-slate-200 dark:border-slate-700",
    "buttonSecondaryBg": "bg-white dark:bg-slate-800",
    "buttonSecondaryHover": "hover:bg-slate-50 dark:hover:bg-slate-700",
    "formBorderLight": "border-gray-300",
    "formTextLight": "text-white",
    "formBgLight": "bg-white/10",
    "statusSuccess": "text-green-600 dark:text-green-400",
    "statusSuccessBg": "bg-green-100",
    "statusWarning": "text-yellow-600 dark:text-yellow-400",
    "statusError": "text-red-600 dark:text-red-400",
    "statusErrorText": "text-red-500",
    "link": "text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300",
    "linkHover": "hover:text-primary-700 dark:hover:text-primary-300",
    "blogPostDate": "text-slate-500",
    "sectionHeadingOnImage": "text-white",
    "sectionTextOnImage": "text-white/90",
    "sectionSubtextOnImage": "text-white/80",
    "itemBgOnImage": "bg-white/90 dark:bg-neutral-900/90 backdrop-blur-sm border-white/30 dark:border-neutral-700/50",
    "statsSectionBg": "bg-primary-900 dark:bg-primary-950",
    "statsNumber": "text-transparent bg-clip-text bg-gradient-to-r from-white to-primary-200 dark:from-white dark:to-primary-300",
    "statsLabel": "text-primary-200 dark:text-primary-300",
    "heroBg": "bg-gradient-to-br from-primary-50 via-white to-accent-50 dark:from-primary-900 dark:via-neutral-900 dark:to-accent-900",
    "heroOverlayText": "text-neutral-50",
    "ctaBg": "bg-accent-600 hover:bg-accent-700",
    "ctaText": "text-white"
  },
  "css": {
    "gradients": {
      "mainBg": {
        "light": [
          "#eeeff1",
          "#d7dbdf",
          "#b4bbc6"
        ],
        "dark": [
          "#1a1e23",
          "#2c323a",
          "#2c323a",
          "#3c4552",
          "#3c4552",
          "#4d596b"
        ]
      },
      "heroOverlay": {
        "light": [
          "rgba(255, 255, 255, 0.1)",
          "rgba(255, 255, 255, 0.05)"
        ],
        "dark": [
          "rgba(0, 0, 0, 0.4)",
          "rgba(0, 0, 0, 0.2)"
        ]
      },
      "heroTitle": {
        "light": [
          "#0d2559",
          "#0f3fa8"
        ],
        "dark": [
          "#ffffff",
          "#c7d4f0"
        ]
      },
      "ctaButton": {
        "light": [
          "#1554e0",
          "#0f3fa8"
        ],
        "dark": [
          "#487bea",
          "#2563eb"
        ]
      },
      "ctaButtonHover": {
        "light": [
          "#487bea",
          "#2563eb"
        ],
        "dark": [
          "#8eabec",
          "#1554e0"
        ]
      },
      "ctaButtonSecondary": {
        "light": [
          "#a855f7",
          "#7e22ce"
        ],
        "dark": [
          "#c084fc",
          "#a855f7"
        ]
      },
      "ctaButtonSecondaryHover": {
        "light": [
          "#7e22ce",
          "#581c87"
        ],
        "dark": [
          "#e9d5ff",
          "#c084fc"
        ]
      },
      "ctaButtonAccent": {
        "light": [
          "#22c55e",
          "#16a34a"
        ],
        "dark": [
          "#34d399",
          "#22c55e"
        ]
      },
      "ctaButtonAccentHover": {
        "light": [
          "#16a34a",
          "#15803d"
        ],
        "dark": [
          "#6ee7b7",
          "#34d399"
        ]
      },
      "stepNumber": {
        "light": [
          "#c5f1db",
          "#0cc063"
        ],
        "dark": [
          "#8beebb",
          "#0cc063"
        ]
      },
      "featureCardHover": {
        "light": [
          "#c5f1db",
          "#0ee677"
        ],
        "dark": [
          "#8beebb",
          "#0cc063"
        ]
      },
      "logo": {
        "light": [
          "#8beebb",
          "#1554e0"
        ],
        "dark": [
          "#8beebb",
          "#487bea"
        ]
      }
    },
    "shadows": {
      "ctaButton": {
        "light": "rgba(37, 99, 235, 0.4)",
        "dark": "rgba(21, 84, 224, 0.3)"
      },
      "ctaButtonHover": {
        "light": "rgba(37, 99, 235, 0.6)",
        "dark": "rgba(21, 84, 224, 0.5)"
      },
      "ctaButtonSecondary": {
        "light": "rgba(168, 85, 247, 0.4)",
        "dark": "rgba(192, 132, 252, 0.3)"
      },
      "ctaButtonSecondaryHover": {
        "light": "rgba(168, 85, 247, 0.6)",
        "dark": "rgba(192, 132, 252, 0.5)"
      },
      "ctaButtonAccent": {
        "light": "rgba(34, 197, 94, 0.4)",
        "dark": "rgba(52, 211, 153, 0.3)"
      },
      "ctaButtonAccentHover": {
        "light": "rgba(34, 197, 94, 0.6)",
        "dark": "rgba(52, 211, 153, 0.5)"
      },
      "stepNumber": {
        "light": "rgba(0, 0, 0, 0.15)",
        "dark": "rgba(0, 0, 0, 0.3)"
      },
      "featureCardBase": {
        "light": "rgba(0, 0, 0, 0.15)",
        "dark": "rgba(0, 0, 0, 0.25)"
      },
      "featureCardHighlight": {
        "light": "rgba(68, 238, 150, 0.3)",
        "dark": "rgba(68, 238, 150, 0.4)"
      },
      "featureCardGlow": {
        "light": "rgba(14, 230, 119, 0.2)",
        "dark": "rgba(14, 230, 119, 0.3)"
      }
    },
    "components": {
      "techCheckmark": {
        "light": "#0ee677",
        "dark": "#0ee677"
      },
      "buttonHoverText": {
        "light": "#fbbf24",
        "dark": "#fbbf24"
      }
    },
    "menu3d": {
      "labelBg": {
        "light": "rgba(255, 255, 255, 0.9)",
        "dark": "rgba(30, 41, 59, 0.9)"
      },
      "labelText": {
        "light": "#1e293b",
        "dark": "#f8fafc"
      },
      "labelBorder": {
        "light": "rgba(0, 0, 0, 0.1)",
        "dark": "rgba(255, 255, 255, 0.1)"
      },
      "labelSelectedBg": {
        "light": "rgba(99, 102, 241, 0.9)",
        "dark": "rgba(129, 140, 248, 0.9)"
      },
      "labelSelectedText": {
        "light": "#ffffff",
        "dark": "#0f172a"
      }
    }
  },
  "rgb": {
    "primary": {
      "50": "238 242 255",
      "100": "224 231 255",
      "200": "199 210 254",
      "300": "165 180 252",
      "400": "129 140 248",
      "500": "99 102 241",
      "600": "79 70 229",
      "700": "67 56 202",
      "800": "55 48 163",
      "900": "49 46 129",
      "950": "30 27 75"
    },
    "accent": {
      "100": "209 250 229",
      "200": "167 243 208",
      "400": "52 211 153",
      "500": "34 197 94",
      "600": "22 163 74",
      "700": "4 120 87"
    },
    "neutral": {
      "50": "248 250 252",
      "100": "241 245 249",
      "200": "226 232 240",
      "300": "203 213 225",
      "400": "148 163 184",
      "500": "100 116 139",
      "600": "71 85 105",
      "700": "51 65 85",
      "800": "30 41 59",
      "900": "15 23 42"
    }
  },
  "themeColor": "#22c55e"
};
